(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-slider"]) return;
  try {
    
$('.blog__recent-images-slider').slick({
    slidesToShow: 1,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    fade:true,
    dots: false,
    arrows:false,
    asNavFor: ".blog__recent-posts-slider",
});

$('.blog__recent-posts-slider').slick({
  centerMode: true,
  centerPadding: '260px',
  slidesToShow: 1,
  prevArrow: '<button type="button" class="slick-prev"></button>',
  nextArrow: '<button type="button" class="slick-next"></button>',
  dots: true,
  asNavFor: ".blog__recent-images-slider",
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px'
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
	$('.homepage-featured-articles__slick').slick({
		slidesToShow: 3,
		arrows: false,
		responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				dots: true
			}
		}
		]
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-carousel"] && !Shopify.designMode) return;
  try {
    
	// homepage slider
	$('.homepage-carousel').slick({
		dots: true,
		prevArrow: '<button type="button" class="slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-next"></button>',
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
		{
			breakpoint: 768,
			settings: {
				arrows: false
			}
		}
		]
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-content-slider"] && !Shopify.designMode) return;
  try {
    
$('.homepage__content-slider').slick({
  centerMode: true,
  centerPadding: '260px',
  slidesToShow: 1,
  prevArrow: '<button type="button" class="slick-prev"></button>',
  nextArrow: '<button type="button" class="slick-next"></button>',
  dots: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px'
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

$('.homepage__content-slider').on('setPosition', function () {
  $(this).find('.slick-slide').height('auto');
  var slickTrack = $(this).find('.slick-track');
  var slickTrackHeight = $(slickTrack).height();
  $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product-carousel"] && !Shopify.designMode) return;
  try {
    
	$('.homepage-product-carousel').slick({
	  variableWidth: true,
	  slidesToShow: 1,
		arrows: true,
		dots: true,
		prevArrow: '<button type="button" class="slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-next"></button>',
	  responsive: [
		{
			breakpoint: 769,
			settings: {
				variableWidth: false,
				dots: true
			}
		}
	  ]
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-about-us"]) return;
  try {
    
	$('.homepage-featured-articles__slick').slick({
		slidesToShow: 3,
		arrows: false,
		responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				dots: true
			}
		}
		]
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
	$('.product-reviews-carousel').slick({
	  dots: false,
	  slidesToShow: 1,
	  centerPadding: '20%',
	  centerMode: true,
	  infinite: true,
	  variableWidth: true,
		autoplay: true,
  	autoplaySpeed: 3000,
		prevArrow: '<button type="button" class="slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-next"></button>',
		responsive: [
		{
			breakpoint: 769,
			settings: {
				variableWidth: false,
				dots: true,
				centerPadding: '0',
				arrows: false
			}
		}
	  ]
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upload-your-garden"] && !Shopify.designMode) return;
  try {
    
	if(!$('.homepage-featured-articles__slick').hasClass("slick-initialized")){
		$('.homepage-featured-articles__slick').slick({
			slidesToShow: 3,
			arrows: false,
			responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					dots: true
				}
			}
			]
		});
	}

  } catch(e) { console.error(e); }
})();
})();
